import * as i0 from '@angular/core';
import { input, computed, ChangeDetectionStrategy, ViewEncapsulation, Component, output, linkedSignal, InjectionToken, inject, signal, viewChild, Injector, Injectable, ViewContainerRef, effect } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
const _c0 = ["*"];
const _c1 = () => ({});
const _c2 = (a0, a1, a2, a3) => ({
  "--srcBadgeBorderColor": a0,
  "--srcBadgeBackgroundColor": a1,
  "--srcBadgeBorderWidth": a2,
  "--srcBadgeTextColor": a3
});
function SourceBadgeComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.number(), " ");
  }
}
const _c3 = [[["", "srcIconPrefix", ""]], "*", [["", "srcIconPostfix", ""]]];
const _c4 = ["[srcIconPrefix]", "*", "[srcIconPostfix]"];
function SourceLoadingComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "circle", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("r", ctx_r0.calculateRadius())("cx", ctx_r0.size() / 2)("cy", ctx_r0.size() / 2)("stroke", ctx_r0.backgroundStrokeColor())("stroke-width", ctx_r0.strokeWidth())("stroke-dasharray", ctx_r0.circumference());
  }
}
const _c5 = [[["", "srcIconPrefix", ""]], "*"];
const _c6 = ["[srcIconPrefix]", "*"];
function SourceButtonComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 1);
    i0.ɵɵelement(1, "path", 3);
    i0.ɵɵelementEnd();
  }
}
function SourceButtonComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "src-loading", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const config_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("size", 16)("progressStrokeColor", "#6B7280")("strokeWidth", 2)("data-testid", (!!config_r3 ? config_r3 == null ? null : config_r3.testID : ctx_r1.testID()) + "-loading-state");
  }
}
function SourceIconButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "src-badge", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("number", ctx_r0.counter())("data-testid", ctx_r0.testID() + "-counter");
  }
}
const _c7 = (a0, a1) => ({
  "--srcLogoLoadingSize": a0,
  "--srcLogoLoadingStroke": a1
});
const _c8 = [[["", "srcIconThumb", ""]]];
const _c9 = ["[srcIconThumb]"];
function SourceSliderComponent_Conditional_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElement(0, "div", 6);
  }
  if (rf & 2) {
    const tick_r1 = ctx.$implicit;
    i0.ɵɵstyleProp("left", tick_r1);
  }
}
function SourceSliderComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 4);
    i0.ɵɵrepeaterCreate(1, SourceSliderComponent_Conditional_5_For_2_Template, 1, 2, "div", 5, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.tickPositions());
  }
}
const _c10 = ["dialogEl"];
const _c11 = a0 => ({
  "src-modal--small": a0
});
const _forTrack0 = ($index, $item) => $item.label;
function SourceModalElementComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function SourceModalElementComponent_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 10);
    i0.ɵɵelement(2, "path", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-testid", ctx_r1.testID() + "-header-back");
  }
}
function SourceModalElementComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function SourceModalElementComponent_Conditional_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "path", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-testid", ctx_r1.testID() + "-header-close");
  }
}
function SourceModalElementComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", ctx, i0.ɵɵsanitizeHtml);
  }
}
function SourceModalElementComponent_Conditional_10_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function SourceModalElementComponent_Conditional_10_For_2_Template_button_click_0_listener() {
      const footerButton_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close(footerButton_r5.action()));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const footerButton_r5 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", footerButton_r5.srcButtonClasses);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", footerButton_r5.label, " ");
  }
}
function SourceModalElementComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵrepeaterCreate(1, SourceModalElementComponent_Conditional_10_For_2_Template, 2, 2, "button", 15, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.data().footerButtons);
  }
}
const _c12 = ["srcModalContainerRef"];
let SourceBadgeComponent = /*#__PURE__*/(() => {
  class SourceBadgeComponent {
    constructor() {
      this.number = input(0, ...(ngDevMode ? [{
        debugName: "number"
      }] : []));
      this.backgroundColor = input('var(--src-color-icon-critical, #B91C1C)', ...(ngDevMode ? [{
        debugName: "backgroundColor"
      }] : []));
      this.type = input(...(ngDevMode ? [undefined, {
        debugName: "type"
      }] : []));
      this.size = input('default', ...(ngDevMode ? [{
        debugName: "size"
      }] : []));
      this.borderColor = input('var(--src-color-bg-default, #FFFFFF)', ...(ngDevMode ? [{
        debugName: "borderColor"
      }] : []));
      this.borderWidth = input('2px', ...(ngDevMode ? [{
        debugName: "borderWidth"
      }] : []));
      this.textColor = input('var(--src-color-text-inverse, #FFFFFF)', ...(ngDevMode ? [{
        debugName: "textColor"
      }] : []));
      this.customClass = input(...(ngDevMode ? [undefined, {
        debugName: "customClass"
      }] : []));
      this.testID = input('', ...(ngDevMode ? [{
        debugName: "testID",
        alias: 'data-testid'
      }] : [{
        alias: 'data-testid'
      }]));
      this.classes = computed(() => {
        const type = this.type();
        const size = this.size();
        const customClass = this.customClass();
        return [type ? `src-badge--${type}` : '', size && !type ? `src-badge--${size}` : '', customClass && Array.isArray(customClass) ? [...customClass] : customClass ?? ''];
      }, ...(ngDevMode ? [{
        debugName: "classes"
      }] : []));
    }
    static {
      this.ɵfac = function SourceBadgeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceBadgeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceBadgeComponent,
        selectors: [["src-badge"]],
        inputs: {
          number: [1, "number"],
          backgroundColor: [1, "backgroundColor"],
          type: [1, "type"],
          size: [1, "size"],
          borderColor: [1, "borderColor"],
          borderWidth: [1, "borderWidth"],
          textColor: [1, "textColor"],
          customClass: [1, "customClass"],
          testID: [1, "data-testid", "testID"]
        },
        ngContentSelectors: _c0,
        decls: 3,
        vars: 10,
        consts: [[1, "src-badge", 3, "ngClass", "ngStyle"]],
        template: function SourceBadgeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵconditionalCreate(1, SourceBadgeComponent_Conditional_1_Template, 1, 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.classes())("ngStyle", ctx.type() ? i0.ɵɵpureFunction0(4, _c1) : i0.ɵɵpureFunction4(5, _c2, ctx.borderColor(), ctx.backgroundColor(), ctx.borderWidth(), ctx.textColor()));
            i0.ɵɵattribute("data-testid", ctx.testID());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.number() ? 1 : -1);
          }
        },
        dependencies: [NgStyle, NgClass],
        styles: [".src-badge{--srcBadgeHeight: 18px;--srcBadgeBorderWidth: 2px;--srcBadgePadding: 2px 4px;--srcBadgeBackgroundColor: var(--src-color-brand-500, darkgreen);--srcBadgeBorderColor: var(--src-color-bg-default, #fff);--srcBadgeTextColor: var(--src-color-text-inverse, #fff);display:inline-block;width:auto;min-width:var(--srcBadgeHeight);height:var(--srcBadgeHeight);padding:var(--srcBadgePadding);vertical-align:top;text-align:center;border-radius:99px;border:var(--srcBadgeBorderWidth) solid var(--srcBadgeBorderColor, #fff);background:var(--srcBadgeBackgroundColor);color:var(--srcBadgeTextColor);font-size:9px;font-weight:700;line-height:1}.src-badge--small{--srcBadgeHeight: 16px;font-size:8px}.src-badge--large{--srcBadgeHeight: 20px;font-size:10px}.src-badge--neutral,.src-badge--informational,.src-badge--success,.src-badge--warning,.src-badge--attention,.src-badge--critical{--srcBadgeHeight: 20px;--srcBadgeBorderWidth: 0px;--srcBadgePadding: 2px 8px;--srcBadgeBackgroundColor: var(--src-color-bg-strong);--srcBadgeTextColor: var(--src-color-text-default, #1f2937);text-align:center;font-family:var(--src-font-family-sans);font-size:var(--src-fs-small);font-style:normal;font-weight:var(--src-fw-medium, 500);line-height:var(--src-lh-small)}.src-badge--neutral{--srcBadgeBackgroundColor: var(--src-color-bg-strong)}.src-badge--informational{--srcBadgeBackgroundColor: #a4e8f2}.src-badge--success{--srcBadgeBackgroundColor: #aee9d1}.src-badge--warning{--srcBadgeBackgroundColor: #ffd79d}.src-badge--attention{--srcBadgeBackgroundColor: #ffea8a}.src-badge--critical{--srcBadgeBackgroundColor: #ffb7b7}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceBadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SourceBadgeType = {
  NEUTRAL: 'neutral',
  INFORMATIONAL: 'informational',
  SUCCESS: 'success',
  WARNING: 'warning',
  ATTENTION: 'attention',
  CRITICAL: 'critical'
};
const SourceBadgeSize = {
  SMALL: 'small',
  DEFAULT: 'default',
  LARGE: 'large'
};
let SourceBannerComponent = /*#__PURE__*/(() => {
  class SourceBannerComponent {
    constructor() {
      this.type = input('default', ...(ngDevMode ? [{
        debugName: "type"
      }] : []));
      this.isCompact = input(false, ...(ngDevMode ? [{
        debugName: "isCompact"
      }] : []));
      this.testID = input('', ...(ngDevMode ? [{
        debugName: "testID",
        alias: 'data-testid'
      }] : [{
        alias: 'data-testid'
      }]));
    }
    static {
      this.ɵfac = function SourceBannerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceBannerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceBannerComponent,
        selectors: [["src-banner"]],
        inputs: {
          type: [1, "type"],
          isCompact: [1, "isCompact"],
          testID: [1, "data-testid", "testID"]
        },
        ngContentSelectors: _c4,
        decls: 4,
        vars: 4,
        consts: [[1, "src-banner", 3, "ngClass"]],
        template: function SourceBannerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c3);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵprojection(2, 1);
            i0.ɵɵprojection(3, 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("src-banner--compact", ctx.isCompact());
            i0.ɵɵproperty("ngClass", ctx.type() !== "default" ? "src-banner--" + ctx.type() : "");
            i0.ɵɵattribute("data-testid", ctx.testID);
          }
        },
        dependencies: [NgClass],
        styles: [".src-banner{--srcBannerPadding: 20px;--srcBannerBackgroundColor: var(--src-color-bg-default-subdued, #f9fafb);--srcBannerBorderWidth: 1px;--srcBannerBorderColor: var(--src-color-border-default, #e5e7eb);--srcBannerTextColor: var(--src-color-text-default, #1f2937);--srcBannerIconColor: var(--src-color-icon-default, #6b7280);--srcBannerBorderRadius: var(--src-br-small, 4px);--srcBannerIconMargin: 16px;display:flex;gap:8px;width:100%;padding:var(--srcBannerPadding, 20px);border:var(--srcBannerBorderWidth) solid var(--srcBannerBorderColor, #fff);border-radius:var(--srcBannerBorderRadius);background:var(--srcBannerBackgroundColor);color:var(--srcBannerTextColor);font-size:var(--src-fs-base, 14px);font-weight:400;line-height:var(--src-lh-base)}.src-banner [srcIconPrefix]{color:var(--srcBannerIconColor)}.src-banner p{margin:0}.src-banner--compact{--srcBannerPadding: 16px;--srcBannerIconMargin: 8px}.src-banner--info{--srcBannerBackgroundColor: #e8f0fd;--srcBannerBorderColor: transparent;--srcBannerIconColor: #2463bc}.src-banner--success{--srcBannerBackgroundColor: var(--src-color-green-50);--srcBannerBorderColor: var(--src-color-green-500);--srcBannerIconColor: var(--src-color-green-500)}.src-banner--critical{--srcBannerBackgroundColor: var(--src-color-bg-critical-subdued);--srcBannerBorderColor: var(--src-color-border-critical-strong);--srcBannerIconColor: var(--src-color-icon-critical)}.src-banner--warning{--srcBannerBackgroundColor: var(--src-color-yellow-50);--srcBannerBorderColor: var(--src-color-yellow-700);--srcBannerIconColor: var(--src-color-yellow-700)}.src-banner__icon{margin-right:var(--srcBannerIconMargin, 8px);color:var(--srcBannerIconColor)}.src-banner__close{position:absolute;top:16px;right:16px;margin-left:auto}.src-banner__close button.src-icon-button{--srcButtonBgColor: transparent}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceBannerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SourceBannerType = {
  DEFAULT: 'default',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  CRITICAL: 'critical'
};
const SourceButtonColorScheme = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DESTRUCTIVE: 'destructive'
};
const SourceButtonSize = {
  SLIM: 'slim',
  SMALL: 'slim',
  MEDIUM: 'medium',
  LARGE: 'large'
};
const SourceButtonType = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset'
};
const SourceButtonAppearance = {
  PLAIN: 'plain',
  DEFAULT: 'default'
};
const sourceButtonDefaultConfig = {
  type: SourceButtonType.BUTTON,
  appearance: 'default',
  colorScheme: SourceButtonColorScheme.SECONDARY,
  size: SourceButtonSize.MEDIUM,
  customClass: '',
  hasDisclosure: false,
  isFullWidth: false,
  iconButton: false,
  isPressed: false,
  isDisabled: false,
  isLoading: false,
  formID: undefined,
  testID: undefined
};
let SourceLoadingComponent = /*#__PURE__*/(() => {
  class SourceLoadingComponent {
    constructor() {
      this.size = input(32, ...(ngDevMode ? [{
        debugName: "size"
      }] : []));
      this.progress = input(null, ...(ngDevMode ? [{
        debugName: "progress"
      }] : []));
      this.lineCap = input('round', ...(ngDevMode ? [{
        debugName: "lineCap"
      }] : []));
      this.backgroundStrokeColor = input('transparent', ...(ngDevMode ? [{
        debugName: "backgroundStrokeColor"
      }] : []));
      this.progressStrokeColor = input('var(--src-color-brand-500, #017BFF)', ...(ngDevMode ? [{
        debugName: "progressStrokeColor"
      }] : []));
      this.strokeWidth = input(3, ...(ngDevMode ? [{
        debugName: "strokeWidth"
      }] : []));
      this.testID = input('', ...(ngDevMode ? [{
        debugName: "testID",
        alias: 'data-testid'
      }] : [{
        alias: 'data-testid'
      }]));
      this.classes = computed(() => [this.progress() !== null ? 'src-loading--progress' : 'src-loading--animation'], ...(ngDevMode ? [{
        debugName: "classes"
      }] : []));
      this.calculateRadius = computed(() => this.size() / 2 - this.strokeWidth() / 2, ...(ngDevMode ? [{
        debugName: "calculateRadius"
      }] : []));
      this.circumference = computed(() => 2 * Math.PI * this.calculateRadius(), ...(ngDevMode ? [{
        debugName: "circumference"
      }] : []));
      this.viewBox = computed(() => `0 0 ${this.size()} ${this.size()}`, ...(ngDevMode ? [{
        debugName: "viewBox"
      }] : []));
      this.percentage = computed(() => Math.round(this.circumference() * (100 - (this.progress() ?? 0)) / 100), ...(ngDevMode ? [{
        debugName: "percentage"
      }] : []));
    }
    static {
      this.ɵfac = function SourceLoadingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceLoadingComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceLoadingComponent,
        selectors: [["src-loading"]],
        inputs: {
          size: [1, "size"],
          progress: [1, "progress"],
          lineCap: [1, "lineCap"],
          backgroundStrokeColor: [1, "backgroundStrokeColor"],
          progressStrokeColor: [1, "progressStrokeColor"],
          strokeWidth: [1, "strokeWidth"],
          testID: [1, "data-testid", "testID"]
        },
        decls: 4,
        vars: 16,
        consts: [[1, "src-loading-container"], ["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 1, "src-loading", 2, "transform", "rotate(-90deg)", 3, "ngClass"], ["fill", "transparent", "stroke-dashoffset", "0"], ["fill", "transparent"]],
        template: function SourceLoadingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1);
            i0.ɵɵconditionalCreate(2, SourceLoadingComponent_Conditional_2_Template, 1, 6, ":svg:circle", 2);
            i0.ɵɵelement(3, "circle", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-testid", ctx.testID());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("--srcLoadingSize", ctx.size());
            i0.ɵɵproperty("ngClass", ctx.classes());
            i0.ɵɵattribute("width", ctx.size())("height", ctx.size())("viewBox", ctx.viewBox());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.progress() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵattribute("r", ctx.calculateRadius())("cx", ctx.size() / 2)("cy", ctx.size() / 2)("stroke", ctx.progressStrokeColor())("stroke-width", ctx.strokeWidth())("stroke-linecap", ctx.lineCap())("stroke-dashoffset", ctx.progress() ? ctx.percentage() : 0)("stroke-dasharray", ctx.progress() ? ctx.circumference() : "");
          }
        },
        dependencies: [NgClass],
        styles: [":host{display:block}.src-loading-container{position:relative;display:flex;justify-content:center;align-items:center;width:100%;height:100%}.src-loading{position:relative;display:inline-block}.src-loading--animation{animation:1.4s linear 0s infinite normal none running rotate}.src-loading--animation circle{transform-origin:50% 50%;stroke-dasharray:calc(var(--srcLoadingSize) * 2 * 1px),calc(var(--srcLoadingSize) * 5 * 1px);stroke-dashoffset:0;animation:1.6s ease-in-out 0s infinite normal none running spinner}@keyframes rotate{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes spinner{0%{stroke-dasharray:1px,calc(var(--srcLoadingSize) * 5 * 1px);stroke-dashoffset:0}50%{stroke-dasharray:calc(var(--srcLoadingSize) * 2.5 * 1px),calc(var(--srcLoadingSize) * 5 * 1px);stroke-dashoffset:calc(var(--srcLoadingSize) * .4 * -1px)}to{stroke-dasharray:calc(var(--srcLoadingSize) * 2.5 * 1px),calc(var(--srcLoadingSize) * 5 * 1px);stroke-dashoffset:calc(var(--srcLoadingSize) * 3 * -1px)}}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceLoadingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SourceButtonComponent = /*#__PURE__*/(() => {
  class SourceButtonComponent {
    constructor() {
      this.type = input('button', ...(ngDevMode ? [{
        debugName: "type"
      }] : []));
      this.appearance = input('default', ...(ngDevMode ? [{
        debugName: "appearance"
      }] : []));
      this.colorScheme = input('secondary', ...(ngDevMode ? [{
        debugName: "colorScheme"
      }] : []));
      this.size = input('medium', ...(ngDevMode ? [{
        debugName: "size"
      }] : []));
      this.customClass = input('', ...(ngDevMode ? [{
        debugName: "customClass"
      }] : []));
      this.hasDisclosure = input(false, ...(ngDevMode ? [{
        debugName: "hasDisclosure"
      }] : []));
      this.isFullWidth = input(false, ...(ngDevMode ? [{
        debugName: "isFullWidth"
      }] : []));
      this.isPressed = input(false, ...(ngDevMode ? [{
        debugName: "isPressed"
      }] : []));
      this.isDisabled = input(false, ...(ngDevMode ? [{
        debugName: "isDisabled"
      }] : []));
      this.isLoading = input(false, ...(ngDevMode ? [{
        debugName: "isLoading"
      }] : []));
      this.iconButton = input(false, ...(ngDevMode ? [{
        debugName: "iconButton"
      }] : []));
      this.srcButtonConfig = input(...(ngDevMode ? [undefined, {
        debugName: "srcButtonConfig"
      }] : []));
      this.formID = input(...(ngDevMode ? [undefined, {
        debugName: "formID"
      }] : []));
      this.testID = input('', ...(ngDevMode ? [{
        debugName: "testID",
        alias: 'data-testid'
      }] : [{
        alias: 'data-testid'
      }]));
      this.onClick = output();
      this.onSubmit = output();
      this.classes = computed(() => {
        const config = this.getConfig(this.srcButtonConfig() ?? {
          type: this.type(),
          appearance: this.appearance(),
          colorScheme: this.colorScheme(),
          size: this.size(),
          customClass: this.customClass(),
          hasDisclosure: this.hasDisclosure(),
          isFullWidth: this.isFullWidth(),
          formID: this.formID(),
          iconButton: this.iconButton(),
          isPressed: this.isPressed(),
          isDisabled: this.isDisabled(),
          isLoading: this.isLoading(),
          testID: this.testID()
        });
        return [config.appearance ? `src-button--${config.appearance}` : '', config.colorScheme ? `src-button--${config.colorScheme}` : '', config.size ? `src-button--${config.size}` : '', config.hasDisclosure ? 'src-button--disclosure' : '', config.isPressed ? 'src-button--pressed' : '', config.isFullWidth ? 'src-button--full-width' : '', config.iconButton ? 'src-button--icon-button' : '', config.isLoading ? 'src-button--loading' : '', config.customClass && Array.isArray(config.customClass) ? [...config.customClass] : config.customClass ?? ''].filter(Boolean);
      }, ...(ngDevMode ? [{
        debugName: "classes"
      }] : []));
    }
    handleClick(event) {
      event.preventDefault();
      this.onClick.emit(event);
    }
    handleSubmit(event) {
      event.preventDefault();
      this.onSubmit.emit(event);
    }
    getConfig(config) {
      return {
        type: config?.type || sourceButtonDefaultConfig.type,
        appearance: config?.appearance || sourceButtonDefaultConfig.appearance,
        colorScheme: config?.colorScheme || sourceButtonDefaultConfig.colorScheme,
        size: config?.size || sourceButtonDefaultConfig.size,
        customClass: config?.customClass || sourceButtonDefaultConfig.customClass,
        hasDisclosure: config?.hasDisclosure || sourceButtonDefaultConfig.hasDisclosure,
        isFullWidth: config?.isFullWidth || sourceButtonDefaultConfig.isFullWidth,
        iconButton: config?.iconButton || sourceButtonDefaultConfig.iconButton,
        isPressed: config?.isPressed || sourceButtonDefaultConfig.isPressed,
        isDisabled: config?.isDisabled || sourceButtonDefaultConfig.isDisabled,
        isLoading: config?.isLoading || sourceButtonDefaultConfig.isLoading,
        formID: config?.formID || sourceButtonDefaultConfig.formID,
        testID: config?.testID || sourceButtonDefaultConfig.testID
      };
    }
    static {
      this.ɵfac = function SourceButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceButtonComponent,
        selectors: [["src-button"]],
        inputs: {
          type: [1, "type"],
          appearance: [1, "appearance"],
          colorScheme: [1, "colorScheme"],
          size: [1, "size"],
          customClass: [1, "customClass"],
          hasDisclosure: [1, "hasDisclosure"],
          isFullWidth: [1, "isFullWidth"],
          isPressed: [1, "isPressed"],
          isDisabled: [1, "isDisabled"],
          isLoading: [1, "isLoading"],
          iconButton: [1, "iconButton"],
          srcButtonConfig: [1, "srcButtonConfig"],
          formID: [1, "formID"],
          testID: [1, "data-testid", "testID"]
        },
        outputs: {
          onClick: "onClick",
          onSubmit: "onSubmit"
        },
        ngContentSelectors: _c6,
        decls: 7,
        vars: 10,
        consts: [[1, "src-button", 3, "click", "submit", "disabled", "ngClass", "type"], ["width", "8", "height", "5", "viewBox", "0 0 8 5", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "disclosure-icon"], [3, "size", "progressStrokeColor", "strokeWidth", "data-testid"], ["d", "M3.40573 4.3L0.805725 1.7C0.489058 1.38333 0.418392 1.021 0.593725 0.613C0.768392 0.204333 1.08073 0 1.53073 0H6.68072C7.13072 0 7.44306 0.204333 7.61772 0.613C7.79306 1.021 7.72239 1.38333 7.40573 1.7L4.80572 4.3C4.70572 4.4 4.59739 4.475 4.48073 4.525C4.36406 4.575 4.23906 4.6 4.10573 4.6C3.97239 4.6 3.84739 4.575 3.73073 4.525C3.61406 4.475 3.50573 4.4 3.40573 4.3Z", "fill", "currentColor"]],
        template: function SourceButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵdeclareLet(0);
            i0.ɵɵelementStart(1, "button", 0);
            i0.ɵɵlistener("click", function SourceButtonComponent_Template_button_click_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleClick($event));
            })("submit", function SourceButtonComponent_Template_button_submit_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleSubmit($event));
            });
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵprojection(3);
            i0.ɵɵprojection(4, 1);
            i0.ɵɵconditionalCreate(5, SourceButtonComponent_Conditional_5_Template, 2, 0, ":svg:svg", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(6, SourceButtonComponent_Conditional_6_Template, 1, 4, "src-loading", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const config_r4 = i0.ɵɵstoreLet(ctx.srcButtonConfig());
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", !!config_r4 ? config_r4 == null ? null : config_r4.isDisabled : ctx.isDisabled())("ngClass", ctx.classes())("type", !!config_r4 ? config_r4 == null ? null : config_r4.type : ctx.type());
            i0.ɵɵattribute("data-testid", !!config_r4 ? config_r4 == null ? null : config_r4.testID : ctx.testID())("form", !!config_r4 ? config_r4 == null ? null : config_r4.formID : ctx.formID());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("opacity", (!!config_r4 ? config_r4 == null ? null : config_r4.isLoading : ctx.isLoading()) ? 0 : 1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional((!!config_r4 ? config_r4 == null ? null : config_r4.hasDisclosure : ctx.hasDisclosure()) ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((!!config_r4 ? config_r4 == null ? null : config_r4.isLoading : ctx.isLoading()) ? 6 : -1);
          }
        },
        dependencies: [NgClass, SourceLoadingComponent],
        styles: ["button.src-button{--srcButtonBgColor: var(--src-color-bg-default);--srcButtonBgHoverColor: var(--src-color-bg-default-hover);--srcButtonBorderRadius: var(--src-br-small, 4px);--srcButtonBoxShadow: 0px 0px 0px 1px var(--src-color-border-strong, #abb2be) inset, 0px 1px 0px 0px rgba(0, 0, 0, .05);--srcButtonFontColor: var(--src-color-text-default);--srcButtonFontSize: var(--src-fs-base);--srcButtonFontWeight: var(--src-fw-medium, 500);--srcButtonLineHeight: var(--src-lh-base);--srcButtonPaddings: 8px 16px;--srcButtonTextTransform: default;--srcButtonWidth: auto;display:flex;justify-content:center;align-items:center;width:var(--srcButtonWidth);padding:var(--srcButtonPaddings);font-weight:var(--srcButtonFontWeight);font-size:var(--srcButtonFontSize);font-style:normal;line-height:var(--srcButtonLineHeight);text-align:center;color:var(--srcButtonFontColor);text-transform:var(--srcButtonTextTransform);letter-spacing:0;white-space:nowrap;background-color:var(--srcButtonBgColor);border:none;border-radius:var(--srcButtonBorderRadius);box-shadow:var(--srcButtonBoxShadow);cursor:pointer}button.src-button>div,button.src-button>span{display:flex;justify-content:center;align-items:center;width:auto}button.src-button:active,button.src-button--pressed{background-color:var(--srcButtonBgHoverColor)}@media (pointer: fine){button.src-button:hover,button.src-button:focus-visible{background-color:var(--srcButtonBgHoverColor)}}button.src-button:disabled,button.src-button[disabled],button.src-button.disabled{cursor:default;pointer-events:none}button.src-button--slim{--srcButtonPaddings: 6px 12px}button.src-button--slim.src-button--icon-prefix{--srcButtonPaddings: 6px 12px 6px 8px}button.src-button--medium{--srcButtonPaddings: 8px 16px}button.src-button--medium.src-button--icon-prefix{--srcButtonPaddings: 8px 16px 8px 12px}button.src-button--large{--srcButtonPaddings: 12px 24px}button.src-button--large.src-button--icon-prefix{--srcButtonPaddings: 12px 24px 12px 20px}button.src-button--primary{--srcButtonBgColor: var(--src-color-bg-primary);--srcButtonBgHoverColor: var(--src-color-bg-primary-hover);--srcButtonBoxShadow: 0px 1px 0px 0px rgba(0, 0, 0, .08), 0px -1px 0px 0px rgba(0, 0, 0, .2) inset;--srcButtonFontColor: var(--src-color-text-inverse)}button.src-button--primary:disabled,button.src-button--primary[disabled]{--srcButtonBgColor: var(--src-color-bg-primary-disabled);--srcButtonBoxShadow: none;--srcButtonFontColor: var(--src-color-text-default-disabled)}button.src-button--secondary{--srcButtonFontColor: var(--src-color-text-default)}button.src-button--secondary:disabled,button.src-button--secondary[disabled]{--srcButtonBgColor: var(--src-color-bg-default-disabled);--srcButtonBoxShadow: none;--srcButtonFontColor: var(--src-color-text-default-disabled)}button.src-button--destructive{--srcButtonBgColor: var(--src-color-bg-critical);--srcButtonBgHoverColor: var(--src-color-bg-critical-strong);--srcButtonBoxShadow: 0px 1px 0px 0px rgba(0, 0, 0, .08), 0px -1px 0px 0px rgba(0, 0, 0, .2) inset;--srcButtonFontColor: var(--src-color-text-inverse)}button.src-button--destructive:disabled,button.src-button--destructive[disabled]{--srcButtonBgColor: var(--src-color-bg-primary-disabled);--srcButtonBoxShadow: none;--srcButtonFontColor: var(--src-color-text-default-disabled)}button.src-button--plain{padding:0;--srcButtonBgColor: transparent;--srcButtonBgHoverColor: transparent;--srcButtonBoxShadow: none}button.src-button--plain:active,button.src-button--plain.src-button--pressed{text-decoration:underline}@media (pointer: fine){button.src-button--plain:hover,button.src-button--plain:focus{text-decoration:underline}}button.src-button--plain:disabled,button.src-button--plain[disabled]{--srcButtonFontColor: var(--src-color-text-default-disabled)}button.src-button--plain.src-button--primary,button.src-button--plain.src-button--primary:active,button.src-button--plain.src-button--primary--pressed{--srcButtonFontColor: var(--src-color-text-primary)}@media (pointer: fine){button.src-button--plain.src-button--primary:hover,button.src-button--plain.src-button--primary:focus{--srcButtonFontColor: var(--src-color-text-primary)}}button.src-button--plain.src-button--destructive,button.src-button--plain.src-button--destructive:active,button.src-button--plain.src-button--destructive--pressed{--srcButtonFontColor: var(--src-color-text-critical)}@media (pointer: fine){button.src-button--plain.src-button--destructive:hover,button.src-button--plain.src-button--destructive:focus{--srcButtonFontColor: var(--src-color-text-critical)}}button.src-button--plain.src-button--secondary{--srcButtonFontColor: var(--src-color-text-default)}button.src-button--plain.src-button--primary:disabled,button.src-button--plain.src-button--primary[disabled],button.src-button--plain.src-button--destructive:disabled,button.src-button--plain.src-button--destructive[disabled],button.src-button--plain.src-button--secondary:disabled,button.src-button--plain.src-button--secondary[disabled]{--srcButtonBgColor: transparent;--srcButtonFontColor: var(--src-color-text-default-disabled)}button.src-button--full-width{--srcButtonWidth: 100%}button.src-button--disclosure{position:relative;--srcButtonDisclosureIconColor: var(--src-color-icon-default)}button.src-button--disclosure span{display:flex;align-items:center}button.src-button--disclosure:disabled,button.src-button--disclosure[disabled]{--srcButtonDisclosureIconColor: var(--src-color-icon-default-disabled)}button.src-button--disclosure .disclosure-icon{display:flex;justify-content:center;align-items:center;flex-shrink:0;width:20px;height:20px;padding:6px;color:var(--srcButtonDisclosureIconColor)}button.src-button--disclosure.src-button--plain.src-button--primary{--srcButtonDisclosureIconColor: var(--src-color-icon-primary)}button.src-button--disclosure.src-button--plain.src-button--destructive{--srcButtonDisclosureIconColor: var(--src-color-icon-critical)}button.src-button--disclosure.src-button--plain.src-button--primary:disabled,button.src-button--disclosure.src-button--plain.src-button--primary[disabled],button.src-button--disclosure.src-button--plain.src-button--destructive:disabled,button.src-button--disclosure.src-button--plain.src-button--destructive[disabled]{--srcButtonDisclosureIconColor: var( --src-color-icon-default-disabled )}button.src-button--disclosure.src-button--primary,button.src-button--disclosure.src-button--destructive{--srcButtonDisclosureIconColor: var(--src-color-text-inverse)}button.src-button--disclosure.src-button--primary:disabled,button.src-button--disclosure.src-button--primary[disabled],button.src-button--disclosure.src-button--destructive:disabled,button.src-button--disclosure.src-button--destructive[disabled]{--srcButtonDisclosureIconColor: var(--src-color-text-inverse)}button.src-button--disclosure.src-button--secondary{--srcButtonDisclosureIconColor: var(--src-color-icon-default)}button.src-button--disclosure.src-button--secondary:disabled,button.src-button--disclosure.src-button--secondary[disabled]{--srcButtonDisclosureIconColor: var(--src-color-icon-default-disabled)}button.src-button [srcIconPrefix]{flex-shrink:0}button.src-button--icon-button{--srcButtonPaddings: 8px}button.src-button--icon-button.src-button--slim{--srcButtonPaddings: 6px}button.src-button--icon-button.src-button--medium{--srcButtonPaddings: 8px}button.src-button--icon-button.src-button--large{--srcButtonPaddings: 12px}button.src-button--loading src-loading{position:absolute}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SourceCopyrightComponent = /*#__PURE__*/(() => {
  class SourceCopyrightComponent {
    constructor() {
      this.linkText = input('Powered by 3D Source', ...(ngDevMode ? [{
        debugName: "linkText"
      }] : []));
      this.isCollapsible = input(false, ...(ngDevMode ? [{
        debugName: "isCollapsible"
      }] : []));
    }
    static {
      this.ɵfac = function SourceCopyrightComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceCopyrightComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceCopyrightComponent,
        selectors: [["src-copyright"]],
        inputs: {
          linkText: [1, "linkText"],
          isCollapsible: [1, "isCollapsible"]
        },
        decls: 6,
        vars: 3,
        consts: [[1, "src-copyright"], ["href", "https://www.3dsource.com/", "target", "_blank", 1, "src-link"], ["fill", "none", "height", "18", "viewBox", "0 0 17 18", "width", "17", "xmlns", "http://www.w3.org/2000/svg", 1, "src-link__icon"], ["fill", "#016EF8", "fill-rule", "evenodd", "d", "M13 13v1.1a61.8 61.8 0 0 1 .2 1.3l2-1.2c.7-.3 1-.9 1-1.6V10c0-.4-.2-.8-.6-1l-4.4-2.5a9414.7 9414.7 0 0 0-2.8-1.7l-.6-.3c-.2-.1-.3-.3-.3-.5 0-.3.2-.4.4-.5l.6.1 3.7 2.2a4320 4320 0 0 1 4 2V5.3c0-.7-.3-1.1-.9-1.5L9.3.3C8.5 0 7.7 0 7 .3L5.7 1l-1.2.7-.2.4v3.3c0 .5.2 1 .7 1.2l4 2.3 3.2 1.8c.6.3.8.8.8 1.4v1ZM3.2 5V4A164.6 164.6 0 0 1 3 2.6l-1.2.7-1 .5c-.5.4-.8.9-.8 1.6V8c0 .4.2.8.6 1l1 .6.5.3 6.2 3.5c.1.1.3.2.3.4.1.2 0 .4-.1.6-.2.2-.4.2-.7 0l-1.8-1-.5-.3-3.3-1.9-2-1C0 10 0 10 0 10.1a914.3 914.3 0 0 1 0 2.4c0 .7.3 1.3 1 1.6L3.8 16l3 1.7c.8.5 1.6.5 2.4 0l1.1-.6 1.3-.7.2-.3v-3.5c0-.5-.2-.8-.6-1a1118.4 1118.4 0 0 1-4-2.4L3.8 7.2c-.4-.2-.7-.7-.7-1.2V5Z", "clip-rule", "evenodd"], [1, "src-link__text"]],
        template: function SourceCopyrightComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵdomElementStart(0, "div", 0)(1, "a", 1);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵdomElementStart(2, "svg", 2);
            i0.ɵɵdomElement(3, "path", 3);
            i0.ɵɵdomElementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵdomElementStart(4, "span", 4);
            i0.ɵɵtext(5);
            i0.ɵɵdomElementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("src-copyright--collapsible", ctx.isCollapsible());
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.linkText());
          }
        },
        styles: [".src-copyright{--srcCopyrightFontSize: 12px;--srcCopyrightFontColor: var(--color-text-default, #1f2937)}.src-copyright--collapsible{--srcCopyrightSize: 32px;--srcCopyrightBoxShadow: 0px 8px 20px 0px rgba(23, 24, 24, .12), 0px 3px 6px 0px rgba(23, 24, 24, .08);--srcCopyrightExpandedWidth: 176px}.src-link{display:flex;align-items:center;font-size:var(--srcCopyrightFontSize);font-style:normal;font-weight:400;line-height:1;color:var(--srcCopyrightFontColor);text-decoration:none;transition:all .3s ease-in-out}.src-link:hover{text-decoration:underline}.src-link .src-link__icon{width:16px;height:18px}.src-link .src-link__text{color:inherit;padding-left:8px;padding-top:1px}.src-copyright--collapsible{width:var(--srcCopyrightSize);height:var(--srcCopyrightSize)}.src-copyright--collapsible .src-link{height:100%;width:var(--srcCopyrightSize);border-radius:8px;text-decoration:none;background:#fff;box-shadow:var(--srcCopyrightBoxShadow)}.src-copyright--collapsible .src-link:hover{width:var(--srcCopyrightExpandedWidth)}.src-copyright--collapsible .src-link:hover .src-link__text{width:100%}.src-copyright--collapsible .src-link__icon{display:flex;align-items:center;justify-content:center;flex-shrink:0;width:var(--srcCopyrightSize);height:var(--srcCopyrightSize);padding:7px}.src-copyright--collapsible .src-link__text{flex-shrink:0;overflow:hidden;white-space:nowrap;padding:0;width:0;transition:width .3s ease-in-out}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceCopyrightComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SourceDividerComponent = /*#__PURE__*/(() => {
  class SourceDividerComponent {
    constructor() {
      this.color = input('#E5E7EB', ...(ngDevMode ? [{
        debugName: "color"
      }] : []));
      this.thickness = input('1px', ...(ngDevMode ? [{
        debugName: "thickness"
      }] : []));
    }
    static {
      this.ɵfac = function SourceDividerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceDividerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceDividerComponent,
        selectors: [["src-divider"]],
        inputs: {
          color: [1, "color"],
          thickness: [1, "thickness"]
        },
        decls: 1,
        vars: 4,
        consts: [[1, "src-divider"]],
        template: function SourceDividerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵdomElement(0, "hr", 0);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("--srcDividerColor", ctx.thickness())("--srcDividerColor", ctx.color());
          }
        },
        styles: [".src-divider{--srcDividerColor: var(--src-color-border-default, #e5e7eb);--srcDividerHeight: 1px;--srcDividerOffsetTop: 8px;--srcDividerOffsetBottom: var(--srcDividerOffsetTop);display:block;width:100%;height:var(--srcDividerHeight);margin-top:var(--srcDividerOffsetTop);margin-bottom:var(--srcDividerOffsetBottom);padding:0;background-color:var(--srcDividerColor);border:none}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceDividerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SourceHintComponent = /*#__PURE__*/(() => {
  class SourceHintComponent {
    constructor() {
      this.isError = input(false, ...(ngDevMode ? [{
        debugName: "isError"
      }] : []));
      this.isCompact = input(false, ...(ngDevMode ? [{
        debugName: "isCompact"
      }] : []));
    }
    static {
      this.ɵfac = function SourceHintComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceHintComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceHintComponent,
        selectors: [["src-hint"]],
        inputs: {
          isError: [1, "isError"],
          isCompact: [1, "isCompact"]
        },
        ngContentSelectors: _c6,
        decls: 3,
        vars: 4,
        consts: [[1, "src-hint"]],
        template: function SourceHintComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵdomElementStart(0, "p", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵprojection(2, 1);
            i0.ɵɵdomElementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("src-hint--error", ctx.isError())("src-hint--compact", ctx.isCompact());
          }
        },
        styles: [".src-hint{--srcHintColor: var(--src-color-icon-default, #6b7280);--srcHintFontSize: var(--src-fs-base, 14px);--srcHintLineHeight: var(--src-lh-base, 1.43);--srcHintMargin: 4px 0 0;--srcHintIconSize: 20px;color:var(--srcHintColor);font-size:var(--srcHintFontSize);font-style:normal;display:flex;margin:var(--srcHintMargin);font-weight:var(--src-fw-regular, 400);line-height:var(--srcHintLineHeight)}.src-hint>[srcIconPrefix]{width:var(--srcHintIconSize);height:var(--srcHintIconSize);margin-right:4px;color:currentColor}.src-hint--error{--srcHintColor: var(--src-color-text-critical, #9f200a)}.src-hint--compact{--srcHintFontSize: var(--src-fs-small, 12px);--srcHintMargin: 2px 0 0}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceHintComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SourceIconButtonComponent = /*#__PURE__*/(() => {
  class SourceIconButtonComponent {
    constructor() {
      this.name = input(...(ngDevMode ? [undefined, {
        debugName: "name"
      }] : []));
      this.type = input('button', ...(ngDevMode ? [{
        debugName: "type"
      }] : []));
      this.size = input('default', ...(ngDevMode ? [{
        debugName: "size"
      }] : []));
      this.shape = input('square', ...(ngDevMode ? [{
        debugName: "shape"
      }] : []));
      this.counter = input(undefined, ...(ngDevMode ? [{
        debugName: "counter"
      }] : []));
      this.isActive = input(false, ...(ngDevMode ? [{
        debugName: "isActive"
      }] : []));
      this.isDisabled = input(false, ...(ngDevMode ? [{
        debugName: "isDisabled"
      }] : []));
      this.testID = input('', ...(ngDevMode ? [{
        debugName: "testID",
        alias: 'data-testid'
      }] : [{
        alias: 'data-testid'
      }]));
      this.onClick = output();
      this.classes = computed(() => [`src-icon-button--${this.shape()}`, `src-icon-button--${this.size()}`, this.isActive() ? 'src-icon-button--active' : ''].filter(Boolean), ...(ngDevMode ? [{
        debugName: "classes"
      }] : []));
    }
    handleClick(event) {
      event.preventDefault();
      if (event.currentTarget instanceof HTMLButtonElement) {
        event.currentTarget.blur();
      }
      this.onClick.emit(event);
    }
    static {
      this.ɵfac = function SourceIconButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceIconButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceIconButtonComponent,
        selectors: [["src-icon-button"]],
        inputs: {
          name: [1, "name"],
          type: [1, "type"],
          size: [1, "size"],
          shape: [1, "shape"],
          counter: [1, "counter"],
          isActive: [1, "isActive"],
          isDisabled: [1, "isDisabled"],
          testID: [1, "data-testid", "testID"]
        },
        outputs: {
          onClick: "onClick"
        },
        ngContentSelectors: _c0,
        decls: 3,
        vars: 6,
        consts: [[1, "src-icon-button", 3, "click", "type", "name", "ngClass", "disabled"], [3, "number", "data-testid"]],
        template: function SourceIconButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function SourceIconButtonComponent_Template_button_click_0_listener($event) {
              return ctx.handleClick($event);
            });
            i0.ɵɵprojection(1);
            i0.ɵɵconditionalCreate(2, SourceIconButtonComponent_Conditional_2_Template, 1, 2, "src-badge", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("type", ctx.type())("name", ctx.name())("ngClass", ctx.classes())("disabled", ctx.isDisabled());
            i0.ɵɵattribute("data-testid", ctx.testID());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.counter() ? 2 : -1);
          }
        },
        dependencies: [NgClass, SourceBadgeComponent],
        styles: ["button.src-icon-button>src-badge{position:absolute;top:-7px;right:-10px}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceIconButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SourceIconButtonSize = {
  XSMALL: 'xs',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  DEFAULT: 'default'
};
const SourceIconButtonType = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset'
};
const SourceIconButtonShape = {
  SQUARE: 'square',
  ROUND: 'round'
};
let SourceLogoLoadingComponent = /*#__PURE__*/(() => {
  class SourceLogoLoadingComponent {
    constructor() {
      this.size = input(32, ...(ngDevMode ? [{
        debugName: "size"
      }] : []));
      this.strokeColor = input('var(--src-color-brand-500)', ...(ngDevMode ? [{
        debugName: "strokeColor"
      }] : []));
      this.testID = input('', ...(ngDevMode ? [{
        debugName: "testID",
        alias: 'data-testid'
      }] : [{
        alias: 'data-testid'
      }]));
    }
    static {
      this.ɵfac = function SourceLogoLoadingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceLogoLoadingComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceLogoLoadingComponent,
        selectors: [["src-logo-loading"]],
        inputs: {
          size: [1, "size"],
          strokeColor: [1, "strokeColor"],
          testID: [1, "data-testid", "testID"]
        },
        decls: 4,
        vars: 5,
        consts: [[1, "src-logo-loading", 3, "ngStyle"], ["xmlns", "http://www.w3.org/2000/svg", "width", "40", "height", "40", "fill", "none", "viewBox", "0 0 40 40"], ["d", "M36.482 12.662v4.466c-1.092-.61-4.316-2.42-7.512-4.213l-5.236-2.938-1.717-.964-.48-.27-.126-.07-.033-.019-.008-.004-.002-.001-.245.435.244-.436a2.552 2.552 0 0 0-.71-.29 2.162 2.162 0 0 0-.758-.015l-.024.003-.024.005c-.49.113-.837.345-1.057.638a1.354 1.354 0 0 0-.275.838c.015.527.4 1.002.988 1.313.643.388 4.642 2.71 8.484 4.937l5.25 3.042 1.703.986.475.275.125.072.032.018.008.005.002.001.25-.432-.25.433.01.005c.477.262.868.868.868 1.673v5.681c-.039 1.216-.675 2.086-1.478 2.553l-.002.001-4.222 2.482v-6.197c.043-.907-.147-1.642-.525-2.236-.375-.589-.909-.998-1.489-1.3l-15.143-8.783c-.324-.195-.572-.42-.74-.689-.167-.266-.272-.6-.272-1.045V5.395a.511.511 0 0 1 .014-.206.122.122 0 0 1 .025-.04.332.332 0 0 1 .087-.064l.006-.004 4.791-2.78.008-.004c.874-.528 1.675-.758 2.433-.762.758-.005 1.512.217 2.293.652l12.45 7.22.003.002c.623.356 1.077.785 1.37 1.301.293.515.445 1.15.41 1.952Z"], ["d", "M3.518 27.338v-4.466c1.092.61 4.316 2.42 7.512 4.213l5.236 2.938 1.717.964.48.27.126.07.033.018.008.005.002.001.245-.435-.244.436c.24.134.464.238.71.29.253.055.494.05.758.015l.024-.003.024-.005c.49-.113.837-.345 1.057-.638.213-.286.281-.598.275-.838-.015-.527-.4-1.002-.988-1.313-.643-.388-4.642-2.71-8.484-4.937l-5.25-3.042-1.703-.986-.475-.275-.125-.072-.032-.018-.008-.005-.002-.001-.25.432.25-.433-.01-.005c-.477-.262-.868-.868-.868-1.673v-5.681c.04-1.216.675-2.086 1.478-2.553l.002-.001 4.222-2.482v6.197c-.043.907.147 1.642.525 2.236.375.589.909.998 1.489 1.3l15.143 8.783c.324.195.572.42.74.689.166.266.272.6.272 1.045v7.227a.511.511 0 0 1-.015.206.122.122 0 0 1-.024.04.334.334 0 0 1-.086.064l-.007.004-4.791 2.78-.008.004c-.874.528-1.675.758-2.433.762-.758.005-1.512-.217-2.293-.652L5.3 30.593l-.003-.002c-.623-.356-1.077-.785-1.37-1.301-.293-.515-.445-1.15-.41-1.952Z"]],
        template: function SourceLogoLoadingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1);
            i0.ɵɵelement(2, "path", 2)(3, "path", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(2, _c7, ctx.size() + "px", ctx.strokeColor()));
            i0.ɵɵattribute("data-testid", ctx.testID());
          }
        },
        dependencies: [NgStyle],
        styles: [".src-logo-loading{--srcLogoLoadingSize: 40px;--srcLogoLoadingStroke: var(--color-brand-500, #016ef8);width:var(--srcLogoLoadingSize);height:var(--srcLogoLoadingSize)}.src-logo-loading svg{width:100%;height:100%}.src-logo-loading path{stroke:var(--srcLogoLoadingStroke);stroke-width:1;fill:none;stroke-dasharray:180;stroke-dashoffset:180;animation:draw 3s linear infinite}@keyframes draw{0%{stroke-dashoffset:180}50%{stroke-dashoffset:0}to{stroke-dashoffset:180}}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceLogoLoadingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SourceSliderComponent = /*#__PURE__*/(() => {
  class SourceSliderComponent {
    constructor() {
      this.id = input(...(ngDevMode ? [undefined, {
        debugName: "id"
      }] : []));
      this.value = input.required(...(ngDevMode ? [{
        debugName: "value"
      }] : []));
      this.sliderValue = linkedSignal(() => this.value());
      this.min = input.required(...(ngDevMode ? [{
        debugName: "min"
      }] : []));
      this.max = input.required(...(ngDevMode ? [{
        debugName: "max"
      }] : []));
      this.thumbSize = input(12, ...(ngDevMode ? [{
        debugName: "thumbSize"
      }] : []));
      this.trackHeight = input(2, ...(ngDevMode ? [{
        debugName: "trackHeight"
      }] : []));
      this.step = input(1, ...(ngDevMode ? [{
        debugName: "step"
      }] : []));
      this.showTicks = input(false, ...(ngDevMode ? [{
        debugName: "showTicks"
      }] : []));
      this.isDisabled = input(false, ...(ngDevMode ? [{
        debugName: "isDisabled"
      }] : []));
      this.orientation = input('horizontal', ...(ngDevMode ? [{
        debugName: "orientation"
      }] : []));
      this.testID = input('', ...(ngDevMode ? [{
        debugName: "testID",
        alias: 'data-testid'
      }] : [{
        alias: 'data-testid'
      }]));
      this.onChange = output();
      this.onInput = output();
      this.tickPositions = computed(() => {
        if (this.showTicks()) {
          const numberOfTicks = (this.max() - this.min()) / this.step();
          return Array.from({
            length: numberOfTicks + 1
          }, (_, index) => {
            const percent = index / numberOfTicks * 100;
            return isNaN(percent) ? '0%' : `${percent}%`;
          });
        }
        return [];
      }, ...(ngDevMode ? [{
        debugName: "tickPositions"
      }] : []));
      this.thumbPosition = computed(() => {
        const percent = (this.sliderValue() - this.min()) * 100 / (this.max() - this.min());
        return isNaN(percent) ? '0%' : `${percent}%`;
      }, ...(ngDevMode ? [{
        debugName: "thumbPosition"
      }] : []));
      this.filledWidth = computed(() => {
        const percent = (this.sliderValue() - this.min()) / (this.max() - this.min()) * 100;
        return isNaN(percent) ? '0%' : `${percent}%`;
      }, ...(ngDevMode ? [{
        debugName: "filledWidth"
      }] : []));
    }
    input(valueEvent) {
      if (valueEvent.target instanceof HTMLInputElement) {
        this.onInput.emit(this.getValue(valueEvent.target));
      }
    }
    change(valueEvent) {
      if (valueEvent.target instanceof HTMLInputElement) {
        this.onChange.emit(this.getValue(valueEvent.target));
      }
    }
    getValue(value) {
      const newValue = value.valueAsNumber;
      const steppedValue = Math.round(newValue / this.step()) * this.step();
      const calculateValue = Math.min(Math.max(steppedValue, this.min()), this.max());
      this.sliderValue.set(calculateValue);
      return newValue;
    }
    static {
      this.ɵfac = function SourceSliderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceSliderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceSliderComponent,
        selectors: [["src-slider"]],
        inputs: {
          id: [1, "id"],
          value: [1, "value"],
          min: [1, "min"],
          max: [1, "max"],
          thumbSize: [1, "thumbSize"],
          trackHeight: [1, "trackHeight"],
          step: [1, "step"],
          showTicks: [1, "showTicks"],
          isDisabled: [1, "isDisabled"],
          orientation: [1, "orientation"],
          testID: [1, "data-testid", "testID"]
        },
        outputs: {
          onChange: "onChange",
          onInput: "onInput"
        },
        ngContentSelectors: _c9,
        decls: 6,
        vars: 21,
        consts: [[1, "src-slider"], ["type", "range", 1, "src-slider__input", 3, "change", "input", "id", "min", "max", "step", "disabled", "value"], [1, "src-slider__filled-track"], [1, "src-slider__thumb"], [1, "src-slider__ticks-container"], [1, "tick", 3, "left"], [1, "tick"]],
        template: function SourceSliderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c8);
            i0.ɵɵdomElementStart(0, "div", 0)(1, "input", 1);
            i0.ɵɵdomListener("change", function SourceSliderComponent_Template_input_change_1_listener($event) {
              return ctx.change($event);
            })("input", function SourceSliderComponent_Template_input_input_1_listener($event) {
              return ctx.input($event);
            });
            i0.ɵɵdomElementEnd();
            i0.ɵɵdomElement(2, "div", 2);
            i0.ɵɵdomElementStart(3, "div", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵdomElementEnd();
            i0.ɵɵconditionalCreate(5, SourceSliderComponent_Conditional_5_Template, 3, 0, "div", 4);
            i0.ɵɵdomElementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("--srcSliderThumbSize", ctx.thumbSize(), "px")("--srcSliderTrackHeight", ctx.trackHeight(), "px");
            i0.ɵɵclassProp("src-slider--disabled", ctx.isDisabled())("src-slider--vertical", ctx.orientation() === "vertical");
            i0.ɵɵattribute("data-testid", ctx.testID());
            i0.ɵɵadvance();
            i0.ɵɵdomProperty("id", ctx.id())("min", ctx.min())("max", ctx.max())("step", ctx.step())("disabled", ctx.isDisabled())("value", ctx.sliderValue());
            i0.ɵɵattribute("data-testid", ctx.testID() + "-input");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.filledWidth());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("left", ctx.thumbPosition());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showTicks() ? 5 : -1);
          }
        },
        styles: [".src-slider{position:relative;--srcSliderThumbBackground: #fff;--srcSliderThumbShadow: 0 0 0 2px #abb2be, 0 2px 0 2px #e6e7e7, 0 0 0 4px #fff;--srcSliderThumbIconColor: var(--src-color-icon-default);--srcSliderClickableTrackHeight: var(--srcSliderThumbSize);--srcSliderTrackShape: 0px;--srcSliderTrackBg: var(--src-color-border-default, #e5e7eb);--srcSliderTrackFilledBg: transparent;--srcSliderTickBg: var(--src-color-border-default, #e5e7eb);--srcSliderTickWidth: 2px;--srcSliderTickHeight: 10px;--srcSliderTickShape: 50%;display:flex;align-items:center}.src-slider--vertical{transform:rotate(-90deg)}.src-slider--disabled{pointer-events:none;--srcSliderThumbShadow: 0 0 0 2px #d1d5db, 0 0 0 4px #fff;--srcSliderTrackBg: #f1f2f3}.src-slider:hover{--srcSliderThumbShadow: 0 0 0 2px #6b7280, 0 2px 0 2px #e6e7e7, 0 0 0 4px #fff}.src-slider input.src-slider__input{width:100%;height:var(--srcSliderClickableTrackHeight);-webkit-appearance:none;appearance:none;background:transparent;cursor:pointer}.src-slider input.src-slider__input::-webkit-slider-thumb{-webkit-appearance:none;width:0;height:0;border:0;background:transparent}.src-slider input.src-slider__input::-moz-range-thumb{width:0;height:0;border:0;background:transparent}.src-slider input.src-slider__input::-webkit-slider-runnable-track{width:100%;height:var(--srcSliderTrackHeight);background:var(--srcSliderTrackBg);border-radius:var(--srcSliderTrackShape)}.src-slider input.src-slider__input::-moz-range-track{width:100%;height:var(--srcSliderTrackHeight);background:var(--srcSliderTrackBg);border-radius:var(--srcSliderTrackShape)}.src-slider input.src-slider__input::-ms-fill-lower{background:var(--srcSliderTrackFilledBg);border-radius:var(--srcSliderTrackShape)}.src-slider__thumb{position:absolute;top:50%;border-radius:50%;background:var(--srcSliderThumbBackground);transform:translate(-50%,-50%);width:var(--srcSliderThumbSize);height:var(--srcSliderThumbSize);display:flex;align-items:center;justify-content:center;color:var(--srcSliderThumbIconColor);box-shadow:var(--srcSliderThumbShadow);z-index:1;transition:all .35s ease;pointer-events:none}.src-slider__thumb>[srcIconThumb]{width:100%;height:100%;object-fit:contain;pointer-events:none}.src-slider__filled-track{position:absolute;top:50%;height:var(--srcSliderTrackHeight);background:var(--srcSliderTrackFilledBg);border-radius:var(--srcSliderTrackShape);left:0;transform:translateY(-50%);pointer-events:none}.src-slider__ticks-container{width:100%;position:absolute;top:50%;height:0}.src-slider__ticks-container .tick{width:var(--srcSliderTickWidth);height:var(--srcSliderTickHeight);transform:translate(-50%,-50%);position:absolute;background:var(--srcSliderTickBg);border-radius:var(--srcSliderTickShape);top:0;pointer-events:none}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceSliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SOURCE_MODAL_ELEMENT_DATA = new InjectionToken('Source Modal data');
let SourceModalElementComponent = /*#__PURE__*/(() => {
  class SourceModalElementComponent {
    constructor() {
      this.data = inject(SOURCE_MODAL_ELEMENT_DATA);
      this.testID = signal(this.data().testID || 'src-modal-element', ...(ngDevMode ? [{
        debugName: "testID"
      }] : []));
      this.dialogEl = viewChild('dialogEl', ...(ngDevMode ? [{
        debugName: "dialogEl"
      }] : []));
      this.closeEvent = output();
      this.closed = output();
    }
    open() {
      this.dialogEl()?.nativeElement.showModal();
    }
    close(result) {
      this.dialogEl()?.nativeElement.close();
      this.closeEvent.emit(result);
      this.closed.emit();
    }
    static {
      this.ɵfac = function SourceModalElementComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceModalElementComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceModalElementComponent,
        selectors: [["src-modal-element"]],
        viewQuery: function SourceModalElementComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.dialogEl, _c10, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        outputs: {
          closeEvent: "closeEvent",
          closed: "closed"
        },
        decls: 11,
        vars: 10,
        consts: [["dialogEl", ""], [1, "src-modal", 3, "ngClass"], [1, "src-modal__header"], ["type", "button", 1, "src-icon-button", "src-icon-button--round", "src-icon-button--sm", "src-modal__back"], [1, "src-modal__title"], ["type", "button", 1, "src-icon-button", "src-icon-button--round", "src-icon-button--sm", "src-modal__close"], [1, "src-modal__body"], [3, "innerHTML"], [1, "src-modal__footer"], ["type", "button", 1, "src-icon-button", "src-icon-button--round", "src-icon-button--sm", "src-modal__back", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 -960 960 960", "fill", "currentColor"], ["d", "m438-480 164 164q11 11 11 25.5T602-265q-11 11-25.5 11t-25.84-11.34L361-455q-5-5.4-7.5-11.7-2.5-6.3-2.5-13.5t2.5-13.5Q356-500 361-505l189.66-189.66Q562-706 576.5-706t25.5 11q11 11 11 25.5T602-644L438-480Z"], ["type", "button", 1, "src-icon-button", "src-icon-button--round", "src-icon-button--sm", "src-modal__close", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", "fill", "none"], ["d", "M10.0001 11.229L6.68618 14.5429C6.51951 14.7096 6.31818 14.7896 6.08218 14.7829C5.84618 14.7756 5.64485 14.6886 5.47818 14.5219C5.31151 14.3553 5.22818 14.1506 5.22818 13.9079C5.22818 13.6646 5.31151 13.4596 5.47818 13.2929L8.77107 10L5.45718 6.68615C5.29051 6.51949 5.21051 6.31482 5.21718 6.07215C5.22451 5.82882 5.31151 5.62382 5.47818 5.45715C5.64485 5.29049 5.84951 5.20715 6.09218 5.20715C6.33551 5.20715 6.54051 5.29049 6.70718 5.45715L10.0001 8.77105L13.314 5.45715C13.4806 5.29049 13.6853 5.20715 13.928 5.20715C14.1713 5.20715 14.3763 5.29049 14.543 5.45715C14.7096 5.62382 14.793 5.82882 14.793 6.07215C14.793 6.31482 14.7096 6.51949 14.543 6.68615L11.2291 10L14.543 13.3139C14.7096 13.4806 14.793 13.6819 14.793 13.9179C14.793 14.1539 14.7096 14.3553 14.543 14.5219C14.3763 14.6886 14.1713 14.7719 13.928 14.7719C13.6853 14.7719 13.4806 14.6886 13.314 14.5219L10.0001 11.229Z", "fill", "currentColor"], ["type", "button", 1, "src-button", 3, "ngClass"], ["type", "button", 1, "src-button", 3, "click", "ngClass"]],
        template: function SourceModalElementComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "dialog", null, 0)(2, "div", 1)(3, "div", 2);
            i0.ɵɵconditionalCreate(4, SourceModalElementComponent_Conditional_4_Template, 3, 1, "button", 3);
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(7, SourceModalElementComponent_Conditional_7_Template, 3, 1, "button", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 6);
            i0.ɵɵconditionalCreate(9, SourceModalElementComponent_Conditional_9_Template, 1, 1, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(10, SourceModalElementComponent_Conditional_10_Template, 3, 0, "div", 8);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_7_0;
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c11, ctx.data().size === "small"));
            i0.ɵɵattribute("data-testid", ctx.testID());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.data().backButton ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵattribute("data-testid", ctx.testID() + "-header-title");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.data().headerTitle, " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.data().closeButton ? 7 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_7_0 = ctx.data().content) ? 9 : -1, tmp_7_0);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.data().footerButtons ? 10 : -1);
          }
        },
        dependencies: [NgClass],
        styles: [".src-modal .src-icon-button svg{width:20px;height:20px}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceModalElementComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SourceModalElementService = /*#__PURE__*/(() => {
  class SourceModalElementService {
    register(viewRef) {
      this.viewRef = viewRef;
    }
    open(data) {
      if (!this.viewRef) throw new Error('Modal container not registered');
      const dataSignal = signal(data, ...(ngDevMode ? [{
        debugName: "dataSignal"
      }] : []));
      const injector = Injector.create({
        providers: [{
          provide: SOURCE_MODAL_ELEMENT_DATA,
          useValue: dataSignal
        }],
        parent: this.viewRef.injector
      });
      const modalRef = this.viewRef.createComponent(SourceModalElementComponent, {
        injector
      });
      modalRef.instance.open();
      modalRef.instance.closed.subscribe(() => {
        this.viewRef?.clear();
      });
      return modalRef;
    }
    static {
      this.ɵfac = function SourceModalElementService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceModalElementService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SourceModalElementService,
        factory: SourceModalElementService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SourceModalElementService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SourceOverlayContainerComponent = /*#__PURE__*/(() => {
  class SourceOverlayContainerComponent {
    constructor() {
      this.srcModalContainerRef = viewChild('srcModalContainerRef', ...(ngDevMode ? [{
        debugName: "srcModalContainerRef",
        read: ViewContainerRef
      }] : [{
        read: ViewContainerRef
      }]));
      this.srcModalElementService = inject(SourceModalElementService);
      this._ = effect(() => {
        this.srcModalElementService.register(this.srcModalContainerRef());
      }, ...(ngDevMode ? [{
        debugName: "_"
      }] : []));
    }
    static {
      this.ɵfac = function SourceOverlayContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SourceOverlayContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SourceOverlayContainerComponent,
        selectors: [["src-overlay-container"]],
        viewQuery: function SourceOverlayContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.srcModalContainerRef, _c12, 5, ViewContainerRef);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        decls: 3,
        vars: 0,
        consts: [["srcModalContainerRef", ""], [1, "overlay-container_3dsourcecom"]],
        template: function SourceOverlayContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵdomElementStart(0, "div", 1);
            i0.ɵɵdomElementContainer(1, null, 0);
            i0.ɵɵdomElementEnd();
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SourceOverlayContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SourceModalSize = {
  SMALL: 'small',
  DEFAULT: 'default'
};

/**
 * Generated bundle index. Do not edit.
 */

export { SourceBadgeComponent, SourceBadgeSize, SourceBadgeType, SourceBannerComponent, SourceBannerType, SourceButtonAppearance, SourceButtonColorScheme, SourceButtonComponent, SourceButtonSize, SourceButtonType, SourceCopyrightComponent, SourceDividerComponent, SourceHintComponent, SourceIconButtonComponent, SourceIconButtonShape, SourceIconButtonSize, SourceIconButtonType, SourceLoadingComponent, SourceLogoLoadingComponent, SourceModalElementComponent, SourceModalElementService, SourceModalSize, SourceOverlayContainerComponent, SourceSliderComponent, sourceButtonDefaultConfig };
